import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { uploadDocument } from '~/generated/sdk.gen';
import { extractData } from '~/utils/query-utils';

type CreateDocumentParams = {
  folderId: string;
  file: File;
};

export const useUploadDocument = (
  options: UseMutationOptions<
    unknown,
    unknown,
    CreateDocumentParams,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ folderId, file }: CreateDocumentParams) => {
      return extractData(
        uploadDocument({
          path: {
            folderId,
          },
          body: {
            file,
          },
        })
      );
    },
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({ queryKey: ['document-share'] });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
